import React, { PropsWithChildren } from "react";
import { SupLinkExternal } from "@repo/core-ui";
import { classNames } from "@/utils";

type DetailsSectionProps = PropsWithChildren<{
  title: string;
  content?: string;
  link?: string;
  linkLabel?: string;
}>;

export default function DetailsSection({ title, content, link, children, linkLabel = undefined }: DetailsSectionProps) {
  return (
    <div className={classNames("mx-4 flex h-[52px] items-center border-b-[0.5px] border-neutral-600 font-mono text-base tracking-wider last:border-b-[0px]")}>
      <p className="w-[150px] whitespace-nowrap text-xs leading-[12px]">{title}</p>
      <div className="mx-[16px] flex w-full items-center justify-between">
        <div className="text-base leading-[16px]">{content || children}</div>
        {link && (
          <div className="flex items-center hover:cursor-pointer hover:opacity-60" onClick={() => window.open(link, "_blank")}>
            {linkLabel && <p className="mr-[8px] whitespace-nowrap text-xs uppercase leading-[12px]">{linkLabel}</p>}
            <SupLinkExternal className="stroke-0" />
          </div>
        )}
      </div>
    </div>
  );
}
